import React from 'react';
import { observer } from 'mobx-react-lite';
import { parseNumberByPrecision } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { winningAmountStore } from '../../store/winningAmountStore';

export const WinPopup = observer(() => {
  const { winningAmount } = winningAmountStore;
  const { currencySymbolOrCode } = userInfoStore;

  if (!winningAmount) {
    return null;
  }

  return (
    <div className='win-popup-wrapper'>
      <div className='win-popup-inner'>
        <p className='win-popup-text'>YOU WIN</p>
        <span className='win-popup-num'>
          {parseNumberByPrecision(1, winningAmount, +userInfoStore.precision || 2)}{' '}
          <span>{currencySymbolOrCode}</span>
        </span>
      </div>
    </div>
  );
});
